import styled from 'styled-components';

const getAccessor = (col, isServiceCatalog) => {
  switch (col.name) {
    case 'worklogDate':
      return 'billedDate';
    case 'details':
      return 'details';
    case 'itemDetails':
      return isServiceCatalog ? 'serviceCatalogItem.name' : 'serviceItem.name';
    default:
      return col.name;
  }
};

const getType = (col) => {
  switch (col.name) {
    case 'worklogDate':
      return 'DateTime';
    case 'invoiceId':
      return 'Link';
    case 'details':
      return 'Multiline';
    case 'itemDetails':
      return 'ServiceItem';
    case 'quantity':
    case 'discountRate':
      return 'TextEdit';
    case 'unitPrice':
    case 'amount':
      return 'Currency';
    case 'tax':
      return 'Tax';
    default:
      return 'Text';
  }
};

const getCellType = (col) => {
  switch (col.name) {
    case 'invoiceId':
      return 'Link';
    default:
      return 'Text';
  }
};

const isEditable = (col) => {
  switch (col.name) {
    case 'details':
    case 'itemDetails':
    case 'quantity':
    case 'unitPrice':
    case 'tax':
    case 'discountRate':
    case 'worklogDate':
      return true;
    default:
      return false;
  }
};

const isBold = (col) => {
  switch (col.name) {
    case 'itemDetails':
    case 'amount':
      return true;
    default:
      return false;
  }
};

const isSortable = (col) => {
  switch (col.name) {
    default:
      return true;
  }
};

const isFilterable = (col) => {
  switch (col?.name) {
    case 'prioritizedId':
      return true;
    default:
      return false;
  }
};

const getRuleAttribute = (f) => {
  switch (f.name) {
    case 'prioritizedId':
      return 'displayId';
    default:
      return f.name;
  }
};

const getWidth = (col) => {
  switch (col.name) {
    case 'worklogDate':
      return 110;
    case 'itemDetails':
      return 150;
    case 'details':
      return 250;
    case 'quantity':
      return 130;
    case 'unitPrice':
      return 100;
    case 'discount':
      return 170;
    default:
      return 150;
  }
};

const getTicketFields = (personalizedColumns) => {
  let fields = personalizedColumns.filter((el) => !el.isCustom);
  let fieldsToRequest = [
    {
      listInfo: ['page', 'pageSize', 'hasMore', 'totalCount']
    }
  ];
  let allFields = [];
  fields.forEach((el) => {
    switch (el.name) {
      case 'client':
        allFields.push({
          client: ['name', 'accountId']
        });
        break;
      case 'requester':
        allFields.push({
          requester: ['name', 'firstName', 'lastName', 'userId']
        });
        break;
      case 'primaryContact':
        allFields.push({
          primaryContact: ['name', 'firstName', 'lastName', 'userId']
        });
        break;
      case 'secondaryContact':
        allFields.push({
          secondaryContact: ['name', 'firstName', 'lastName', 'userId']
        });
        break;
      case 'accountManager':
        allFields.push({
          accountManager: ['name', 'firstName', 'lastName', 'userId']
        });
        break;
      case 'stageStatus':
        allFields = allFields.concat(['stage', 'status']);
        break;
      default:
        allFields.push(el.name);
    }
  });
  if (personalizedColumns.length !== fields.length)
    allFields.push('customFields');
  allFields.push('accountId');
  fieldsToRequest.push({
    clients: allFields
  });
  return fieldsToRequest;
};

const dependencyMap = {
  subcause: 'cause',
  subcategory: 'category',
  technician: 'techGroup'
};

const isDependantField = (field) => {
  return Object.keys(dependencyMap).indexOf(field) > -1;
};

const getParentField = (child) => {
  return dependencyMap[child];
};

const getDependantField = (parent) => {
  return Object.keys(dependencyMap).find(
    (key) => dependencyMap[key] === parent
  );
};

export {
  getAccessor,
  getType,
  getCellType,
  getWidth,
  isSortable,
  isEditable,
  isFilterable,
  getRuleAttribute,
  getTicketFields,
  dependencyMap,
  getDependantField,
  getParentField,
  isDependantField,
  isBold
};
